import Logger from '../logger';
import event from '../mixins/event';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class ThemeHeader {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'ThemeHeader';

		this.dom = dom;

		this.bar = this.dom.querySelector(`[data-theme-header-bar]`);
		this.menuToggleDoms = this.dom.querySelectorAll(`[data-theme-mobile-header-toggle-button]`);
		this.navDom = this.dom.querySelector(`[data-theme-header-nav]`);
		this.headerActiveClass = `theme-header--active`;

		this.dropdownButtonDoms = this.dom.querySelectorAll(`[data-theme-header-dropdown-button]`);
		this.dropdownDoms = this.dom.querySelectorAll(`[data-theme-header-dropdown]`);

		this.mobileDropdownButtonDoms = this.dom.querySelectorAll(`[data-theme-mobile-header-dropdown-button]`);
		this.mobileDropdownDoms = this.dom.querySelectorAll(`[data-theme-mobile-header-dropdown]`);
	}

	/**
	 * init - Initialize the form
	 */
	init() {
		Logger.info(`${this.NAME} > init`);
		this.initDropdownButtons();
		this.initMobileDropdownButtons();
		this.initPinning();
		this.initToggle();
	}

	/**
	 * initDropdownButtons - Initialize the dropdown buttons
	 */
	initDropdownButtons() {
		Logger.info(`${this.NAME} > initDropdownButtons`);

		this.dropdownButtonDoms.forEach((dropdownButton, index) => {
			dropdownButton.addEventListener('click', () => {
				this.toggleDropdown(index);
			});
		});
	}

	/**
	 * initMobileDropdownButtons - Initialize the mobile dropdown buttons
	 */
	initMobileDropdownButtons() {
		Logger.info(`${this.NAME} > initMobileDropdownButtons`);

		this.mobileDropdownButtonDoms.forEach((dropdownButton, index) => {
			dropdownButton.addEventListener('click', () => {
				const idx = dropdownButton.getAttribute(`data-theme-mobile-header-dropdown-button`);
				this.toggleMobileDropdown(idx);
			});
		});
	}

	/**
	 * initPinning - Initialize the pinning of the header
	 */
	initPinning() {
		Logger.info(`${this.NAME} > initPinning`);

		ScrollTrigger.create({
			markers: false,
			trigger: document.body,
			start: 'top -10%',
			end: 'max',
			onUpdate: self => {
				if (self.direction === 1) {
					this.bar.classList.add(`theme-header__bar--scrolling-down`);
					this.bar.classList.remove(`theme-header__bar--scrolling-up`);
				} else {
					this.bar.classList.add(`theme-header__bar--scrolling-up`);
					this.bar.classList.remove(`theme-header__bar--scrolling-down`);
				}
			},
			onLeaveBack: () => {
				this.bar.classList.remove(`theme-header__bar--scrolling-up`);
			},
		});
	}

	/**
	 * initToggle - Initialize the toggle button
	 */
	initToggle() {
		Logger.info(`${this.NAME} > initToggle`);

		const self = this;
		this.menuToggleDoms.forEach((menuToggleDom) => {
			menuToggleDom.addEventListener('click', self.toggleNav.bind(this));
		});
	}

	/**
	 * toggleDropdown - Show the dropdown
	 */
	toggleDropdown(idx) {
		Logger.info(`${this.NAME} > toggleDropdown`);

		// Show the dropdown
		this.dropdownDoms.forEach((dropdown, index) => {
			if (idx === index) {
				if (!dropdown.classList.contains('theme-header__dropdown--active')) {
					dropdown.classList.add('theme-header__dropdown--active');
				} else {
					dropdown.classList.remove('theme-header__dropdown--active');
				}
			} else {
				dropdown.classList.remove('theme-header__dropdown--active');
			}
		});

		// Check to see if any dropdown is open
		let hasOpenDropdown = false;
		this.dropdownDoms.forEach((dropdown, index) => {
			if (dropdown.classList.contains('theme-header__dropdown--active')) {
				hasOpenDropdown = true;
			}
		});
		if (hasOpenDropdown) {
			this.bar.classList.add('theme-header__bar--dropdown-open');
		} else {
			this.bar.classList.remove('theme-header__bar--dropdown-open');
		}

		// Get the idx of the open dropdown
		let openDropdownIdx = null;
		this.dropdownDoms.forEach((dropdown, index) => {
			if (dropdown.classList.contains('theme-header__dropdown--active')) {
				openDropdownIdx = dropdown.getAttribute('data-theme-header-dropdown');
			}
		});

		// Find the dropdown button and add the active class
		this.dropdownButtonDoms.forEach((dropdownButton, index) => {
			if (openDropdownIdx && openDropdownIdx === dropdownButton.getAttribute('data-theme-header-dropdown-button')) {
				dropdownButton.classList.add('theme-header__nav-list-button--open');
			} else {
				dropdownButton.classList.remove('theme-header__nav-list-button--open');
			}
		});
	}

	/**
	 * toggleMobileDropdown - Show the mobile dropdown
	 */
	toggleMobileDropdown(idx) {
		Logger.info(`${this.NAME} > toggleMobileDropdown`);

		// Show the dropdown
		this.mobileDropdownDoms.forEach((dropdown, index) => {
			if (idx === dropdown.getAttribute('data-theme-mobile-header-dropdown')) {
				if (!dropdown.classList.contains('theme-mobile-header__dropdown--active')) {
					dropdown.classList.add('theme-mobile-header__dropdown--active');
				} else {
					dropdown.classList.remove('theme-mobile-header__dropdown--active');
				}
			} else {
				dropdown.classList.remove('theme-mobile-header__dropdown--active');
			}
		});

		// Get the idx of the open dropdown
		let openDropdownIdx = null;
		this.mobileDropdownDoms.forEach((dropdown, index) => {
			if (dropdown.classList.contains('theme-mobile-header__dropdown--active')) {
				openDropdownIdx = dropdown.getAttribute('data-theme-mobile-header-dropdown');
			}
		});

		// Find the dropdown button and add the active class
		this.mobileDropdownButtonDoms.forEach((dropdownButton, index) => {
			if (openDropdownIdx && openDropdownIdx === dropdownButton.getAttribute('data-theme-mobile-header-dropdown-button')) {
				dropdownButton.classList.add('theme-mobile-header__nav-list-button--open');
			} else {
				dropdownButton.classList.remove('theme-mobile-header__nav-list-button--open');
			}
		});
	}

	/**
	 * toggleNav - Toggle the navigation
	 */
	toggleNav() {
		Logger.info(`${this.NAME} > toggleNav`);

		this.dom.classList.toggle(this.headerActiveClass);

		this.trigger('ThemeHeader:search_toggled', this.dom?.classList.contains(this.headerActiveClass));
	}

}

Object.assign(ThemeHeader.prototype, event);

export default ThemeHeader;
